module.exports = __webpack_public_path__ + "static/media/smallDeliveryTruck_gray.a6ac2d80.svg";